module.exports = __webpack_public_path__ + "static/media/icon-blue-jeans.303f9dc9.svg";